<template>
  <div style="display: flex;flex-direction: column;align-items: center;">
    <el-form label-position="right" label-width="100px" :inline="true" style="padding-top: 10px">
      <el-form-item label="产线名称">
        <el-input class="el-input" v-model="this.schedule.lineName" placeholder="产线名称" disabled />
      </el-form-item>
      <el-form-item label="时间组名称">
        <el-input class="el-input" v-model="this.schedule.schedule_name" placeholder="时间组名称" />
      </el-form-item>
      <el-form-item label="工作时间">
        <el-time-picker
            v-model="this.schedule.work_begin_time"
            placeholder="开始时间"
            format="HH:mm"
            value-format="HH:mm:ss"
        />
        <el-time-picker
            style="margin-left: 10px"
            v-model="this.schedule.work_end_time"
            placeholder="结束时间"
            format="HH:mm"
            value-format="HH:mm:ss"
        />
        <el-button v-if="type === 'add'" style="margin-left: 10px" type="primary" @click="addRestSchedule()">添加休息</el-button>
      </el-form-item>
      <div v-for="item in this.restSchedules" :key="item.id">
        <el-form-item label="休息备注">
          <div style="display: flex;">
            <el-input v-model="item.rest_remark" placeholder="休息备注"/>
            <el-button v-if="type === 'add'" style="margin-left: 10px" type="primary" @click="delRestSchedule(item.id)">删除休息</el-button>
          </div>
        </el-form-item>
        <el-form-item label="休息时间">
          <el-time-picker
              v-model="item.rest_begin_time"
              placeholder="开始时间"
              format="HH:mm"
              value-format="HH:mm:ss"
          />
          <el-time-picker
              style="margin-left: 10px"
              v-model="item.rest_end_time"
              placeholder="结束时间"
              format="HH:mm"
              value-format="HH:mm:ss"
          />
        </el-form-item>
      </div>
      <div style="text-align: center">
        <el-button v-if="this.type === 'add'" type="primary" @click="addSchedule()">保存</el-button>
        <el-button v-if="this.type === 'update'" type="primary" @click="updateZuLiLineSchedule()">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "MfgZuLiAttLineScheduleForm",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return{
      schedule:{},
      restSchedules:[],
      type:'add'
    }
  },
  methods:{
    addRestSchedule(){
      let restSchedule = {
        id:Date.now(),
        rest_begin_time:null,
        rest_end_time:null
      }
      this.restSchedules.push(restSchedule)
    },

    delRestSchedule(id){
      for (let i = this.restSchedules.length - 1; i >= 0; i--) {
        if (this.restSchedules[i].id === id){
          this.restSchedules.splice(i,1)
        }
      }
    },

    async addSchedule(){
      this.schedule.restSchedules = this.restSchedules
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/addLineSchedule',this.schedule);
      if (res.code === 0){
        this.$message.success("添加成功！")
        this.setting.$fn.closeWindow()
        this.setting.$fn.reSearch()
      }else {
        this.$message.error(res.message)
      }
    },

    async updateZuLiLineSchedule(){
      this.schedule.restSchedules = this.restSchedules
      console.log(this.schedule)
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/updateZuLiLineSchedule',this.schedule);
      if (res.code === 0){
        this.$message.success("修改成功！")
        this.setting.$fn.closeWindow()
        this.setting.$fn.reSearch()
      }else {
        this.$message.error(res.message)
      }
    },

    async getLineName(){
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/getLineName',this.schedule.line_id);
      this.schedule.lineName = res.data
    },

    async getScheduleRest(){
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/getScheduleRest',this.schedule.id);
      this.restSchedules = res.data
    }
  },
  created() {
    if (this.parentData.button_id === "mfg_zuli_work_time_query"){
      this.schedule.line_id = '3';
    }
    if (this.parentData.button_id === "mfg_work_time_update_zuli"){
      this.schedule = this.parentData
      this.type = 'update'
      this.getScheduleRest()
    }
    this.getLineName()
    console.log(this.parentData)
  }
}
</script>

<style scoped>

</style>